/**
 * Конфигурация компонента бассейна (Pool)
 */
export const POOL_CONFIG = {
    // Базовые размеры "номинальной" чаши для внутренних расчётов сетки и текстур.
    // Эти размеры больше НЕ привязаны к старым GLB-моделям, а являются абстрактной
    // эталонной геометрией для скиммерного и переливного бассейнов.
    SKIMMER_MODEL: {
        WIDTH: 1.3,
        HEIGHT: 0.542,
        LENGTH: 1.3,
    },
    OVERFLOW_MODEL: {
        WIDTH: 1.3,
        HEIGHT: 0.542,
        LENGTH: 1.3,
    },

    // Базовые размеры для расчета тайлинга текстур
    TEXTURE_DEFAULTS: {
        BASE_LENGTH: 3,
        BASE_WIDTH: 3,
        BASE_DEPTH: 1.5,

        // Повторения для стен
        BASE_WALL_REPEAT_LENGTH: 19,
        BASE_WALL_REPEAT_WIDTH: 19,
        BASE_WALL_REPEAT_HEIGHT: 19,

        // Повторения для пола
        BASE_FLOOR_REPEAT_LENGTH: 14,
        BASE_FLOOR_REPEAT_WIDTH: 14,

        // Коэффициент роста повторений при увеличении размера
        GROWTH_EXPONENT: 0.45,
    },
};

/**
 * Геометрические константы процедурных 3D-моделей бассейнов.
 * ЕДИНСТВЕННЫЙ ИСТОЧНИК ПРАВДЫ для SimpleSquarePoolModel,
 * OverflowSquarePoolModel и ProceduralPoolGrid.
 *
 * Если нужно изменить геометрию — меняй ТОЛЬКО здесь.
 */
export const PROC_POOL_GEOMETRY = {
    /**
     * Масштабный коэффициент для горизонтальных осей X и Z.
     * Видимый размер модели = реальный_размер * SCALE_XZ
     */
    SCALE_XZ: 0.765,

    /**
     * Толщина внешнего бетонного основания стены (от внутренней грани до внешней).
     */
    BASE_CONCRETE_THICKNESS: 0.2,

    /**
     * Коэффициент для перевода глубины (D, метры) в высоту стены в единицах сцены.
     * wallHeight = depth * WALL_HEIGHT_FACTOR
     */
    WALL_HEIGHT_FACTOR: 0.433,

    /**
     * Толщина слоя отделки (штукатурка, пленка, мозаика).
     */
    PLASTER_THICKNESS: 0.005,

    /**
     * Толщина бетонного дна чаши.
     */
    BOTTOM_CONCRETE_THICKNESS: 0.03,

    /**
     * Смещение всей группы бассейна по оси Y.
     * Задаётся в компонентах SimpleSquarePoolModel и OverflowSquarePoolModel
     * как group position={[0, POOL_GROUP_Y_OFFSET, 0]}.
     */
    POOL_GROUP_Y_OFFSET: -0.35,

    /**
     * Размер фаски внешнего бетонного борта (bevel для скиммерного).
     */
    SKIMMER_BEVEL_SIZE: 0.01,
};

/**
 * Мир Y: нижняя грань бетонного дна чаши (скиммерный и переливный, процедурные модели).
 * Совпадает с геометрией дна в SimpleSquarePoolModel / OverflowSquarePoolModel.
 */
export const POOL_LOWEST_WORLD_Y =
    PROC_POOL_GEOMETRY.POOL_GROUP_Y_OFFSET - PROC_POOL_GEOMETRY.SKIMMER_BEVEL_SIZE;
